package org.hs_soft.runmynesto.pages.components

import androidx.compose.runtime.Composable
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.attrsModifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.onMouseLeave
import com.varabyte.kobweb.compose.ui.modifiers.onMouseOver
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.silk.components.text.SpanText
import org.hs_soft.runmynesto.domain.config.Dimen
import org.hs_soft.runmynesto.domain.config.FontFamily
import org.hs_soft.runmynesto.domain.config.FontSizes
import org.hs_soft.runmynesto.domain.config.Theme
import org.hs_soft.runmynesto.domain.config.rippleEffect
import org.hs_soft.runmynesto.domain.config.transitionBackground
import org.hs_soft.runmynesto.domain.model.home.template.GridItemsFilterEnum
import org.hs_soft.runmynesto.domain.util.Res
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.backgroundImage
import org.jetbrains.compose.web.css.backgroundPosition
import org.jetbrains.compose.web.css.backgroundRepeat
import org.jetbrains.compose.web.css.height
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.width

@Composable
fun FilterComponent(
    modifier: Modifier = Modifier,
    title: String,
    selectedFilterType: GridItemsFilterEnum?=null,
    onFilterClick: () -> Unit,
) {
    val isHovered= remember { mutableStateOf(false) }

    Row(
        modifier = modifier
            .height(Dimen.filterHeight)
            .width(Dimen.filterWidth)
            .cursor(Cursor.Pointer)
            .onMouseLeave {
                isHovered.value=false
            }
            .onMouseOver {
                isHovered.value=true
            }
            .padding(
                leftRight = Dimen.mediumPadding,
            )
            .transitionBackground()
            .backgroundColor(
                if (isHovered.value) Theme.PrimaryStatesHover.rgb
                else Theme.Transparent.rgb
            )
            .border(
                width = Dimen.smallThickness,
                style = LineStyle.Solid,
                color =Theme.PrimaryStatesOutlinedBorder.rgb
            )
            .rippleEffect {
                it.stopPropagation()
                onFilterClick()
            }
            .borderRadius(r = Dimen.lowBorderRadius),
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.Center
    )
    {
        Box(
            modifier = Modifier
                .attrsModifier {
                    style {
                        width(Dimen.semiNormalIconSize.px)
                        height(Dimen.semiNormalIconSize.px)
                        backgroundPosition("center")
                        backgroundRepeat("no-repeat")
                        backgroundImage(
                            if (selectedFilterType!=GridItemsFilterEnum.ALL_ITEMS)
                                Res.PathIcon.filterAltHas
                            else Res.PathIcon.filterAltFilled
                        )
                    }
                }
        )


        SpanText(
            text = title,
            modifier = Modifier
                .margin(Dimen.smallPadding)
                .fontSize(FontSizes.mediumFontSize)
                .color(Theme.PrimaryMain.rgb)
                .cursor(Cursor.Pointer)
                .fontFamily(FontFamily.Jakarta)
                .fontWeight(FontWeight.SemiBold)
        )

    }
}